import { Directive, Renderer, ElementRef, Input } from "@angular/core";
@Directive({
  selector: "[statusTransaction]",
})
export class StatusTransactionDirective {
  @Input("status") st;

  constructor(private el: ElementRef, private renderer: Renderer) {
    setTimeout(() => {
      this.check();
    }, 0);
  }
  check() {
    var addClass = "";
    var status = "";
    if (this.st == 1) {
      addClass = "badge-warning";
      status = "Draft";
    } else if (this.st == 2) {
      addClass = "badge-primary";
      status = "Pending For Approval";
    } else if (this.st == 3) {
      addClass = "badge-success";
      status = "Approved";
    } else if (this.st == 4) {
      addClass = "badge-danger";
      status = "Rejected";
    }
    if (addClass && status) {
      var d1 = this.el.nativeElement;
      d1.insertAdjacentHTML(
        "beforeend",
        '<span class="text-white">' + status + "</span>"
      );
      this.renderer.setElementClass(this.el.nativeElement, "badge", true);
      this.renderer.setElementClass(this.el.nativeElement, addClass, true);
    }
  }
}
export const StatusTransaction_DIRECTIVES = [StatusTransactionDirective];



// WEBPACK FOOTER //
// /app/src/app/directives/status-transaction/status-transaction.directive.ts